/**
 * 设备管理-校牌管理-异常监控管理
 */
import request from '@/utils/request';
// import { getToken } from '@/utils/auth';
// import ENVIRONMENT from '@/utils/environment';

/**
  * 获取异常监控管理员列表
  */
export function getMonitoradminsList(options) {
  return request({
    url: `/op/monitoradmins/`,
    method: 'get',
    params: options
  });
}
/**
  * 添加异常监控管理员
  */
export function getMonitorrulesAdd(options) {
  return request({
    url: `op/monitoradmins/`,
    method: 'post',
    data: options
  });
}
/**
  * 删除异常监控管理员
  */
export function getMonitorrulesDel(id) {
  return request({
    url: `/op/monitoradmins/${id}`,
    method: 'DELETE'
  });
}
/**
  * 查询监控规则
  */
export function getMonitorrules(options) {
  return request({
    url: `op/monitorrules/`,
    method: 'get',
    params: options
  });
}
/**
  * 删除监控规则
  */
export function getMonitorRuleDel(id) {
  return request({
    url: `op/monitorRule/${id}`,
    method: 'DELETE'
  });
}/**
  * 设置监控规则
  */
export function getMonitorrulesSet(data) {
  return request({
    url: `op/monitorrules/`,
    method: 'post',
    data
  });
}

// ---------------- 校牌型号
// 列表
export function modelList() {
  return request({
    url: `/op/school-plate-type/`,
    method: 'get'
  });
}
// 查询校牌类型集合
export function modelTypeList() {
  return request({
    url: `/op/school-plate-type/type`,
    method: 'get'
  });
}
// 新增
export function addModel(data) {
  return request({
    url: `/op/school-plate-type/`,
    method: 'POST',
    data
  });
}
// 修改
export function updateModel(id, data) {
  return request({
    url: `/op/school-plate-type/${id}`,
    method: 'PUT',
    data
  });
}
// 删除
export function deleteModel(id) {
  return request({
    url: `/op/school-plate-type/${id}`,
    method: 'DELETE'
  });
}
// 判断类型TAC是否已经绑定
export function isBindModel(id) {
  return request({
    url: `/op/school-plate-type/validate-tac-bind/${id}`,
    method: 'POST'
  });
}
